//
// React
//
import React from 'react';

const ComponentsRegistryContext = React.createContext({
    components: {},
});
export default ComponentsRegistryContext;
